import React, { useState, useEffect, MouseEvent } from 'react';
import { useSelector } from 'react-redux';
import { State } from 'app/scripts/state/store-types';

type Props = {
  name: 'POSTS' | 'COMMENTS';
  isAuthorized: boolean;
  onMount: Function;
  onUnmount: Function;
  onClick?: (e: MouseEvent) => any;
  disabled?: boolean;
};

const Notification = ({
  name,
  isAuthorized = true,
  disabled = false,
  onClick = (e: MouseEvent) => {},
  onMount = () => {},
  onUnmount = () => {}
}: Props) => {
  const [isPolling, setIsPolling] = useState<boolean>(false);
  const count = useSelector(
    (state: State) => state.navigation?.notifications?.[name.toLowerCase()]
  );

  useEffect(() => {
    return () => onUnmount();
  }, []);

  useEffect(() => {
    const shouldPollNotification = isAuthorized && !disabled;

    if (shouldPollNotification && !isPolling) {
      setIsPolling(true);
      onMount();
    }

    if (!shouldPollNotification && isPolling) {
      setIsPolling(false);
      onUnmount();
    }
  }, [isAuthorized, disabled, count]);

  if (disabled || !count || count < 1) {
    return null;
  }

  return (
    <div className="notify-bar" onClick={onClick}>
      {count}
    </div>
  );
};

export default Notification;
